import React, { useEffect, useState } from "react";
import Headers from "../Components/Headers";
import Footer from "../Components/Footers";

const VideoAccessList = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch("/api/video/views")
      .then(res => res.json())
      .then(data => setRows(data));
  }, []);

  return (
    <>
      <Headers />

      <div className="mom-page">
        <h1 className="mom-title">Video Access</h1>
        <p className="mom-subtitle">
          The Rules We Inherit
        </p>

        <div className="mom-card">
          <div className="mom-table-head">
            <span>Name</span>
            <span>Email</span>
            <span>Video</span>
          </div>

          {rows.length === 0 && (
            <p className="mom-empty">No data available</p>
          )}

          {rows.map((row, i) => (
            <div key={i} className="mom-table-row">
              <div>
                <label>Name</label>
                <span>{row.username}</span>
              </div>
              <div>
                <label>Email</label>
                <span>{row.email}</span>
              </div>
              <div>
                <label>Video</label>
                <span>The Rules We Inherit</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default VideoAccessList;
